import { useRouter } from "next/router";

import { Loader } from "components/customElements/loader";
import ProfileSnippet from "components/ProfileSnippet";
import { useApi } from "hooks/useApi";
import { ApiEndpoint, baseFetcher } from "utils/baseFetcher";

type ProfilePageTeamListProps = {};

export const profileAnalystsUrl = (slug: string) => {
  const url = new ApiEndpoint(`/api/v2/companies/${slug}/analysts`);
  url.searchParams.append("include", "company,introducer");
  url.searchParams.append("sort", "name");

  return url.href;
};

export const fetcher = (endpoint: string) => {
  return baseFetcher(endpoint, undefined, {
    // comments: {
    //   valueForRelationship(relationship: { id: string }) {
    //     return {
    //       id: relationship.id,
    //     };
    //   },
    // },
  });
};

const ProfilePageTeamList = ({}: ProfilePageTeamListProps) => {
  const router = useRouter();
  const slug = router.query.slug as string;

  const { data: accounts, isValidating } = useApi(
    profileAnalystsUrl(slug),
    baseFetcher
  );

  return (
    <>
      <div className="">
        <div className="min-h-[20vh] flex flex-col divide-x-0 divide-y divide-solid divide-black/20">
          {isValidating ? (
            <Loader />
          ) : (
            accounts?.data?.map?.((profile: any) => (
              <div key={profile.slug}>
                <div className="mx-[-15px]">
                  <ProfileSnippet
                    profile={profile}
                    showFollowButton
                    full
                    showMessageButton
                  />
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default ProfilePageTeamList;
